import { Compass } from 'lucide-react'

import Link from '@/lib/navigation/link'

/** The 404 page (src/pages/404.tsx's body), shared by the Next page and the SPA. */
export default function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 px-4 pt-12.5 text-center">
      <div className="flex size-12 items-center justify-center rounded-card bg-surface text-muted-foreground">
        <Compass aria-hidden className="size-6" />
      </div>
      <h1 className="type-h3 text-foreground">We can&apos;t find that page</h1>
      <p className="type-body text-body">Check the address, or go to your dashboard.</p>
      <Link href="/" className="font-medium text-primary underline underline-offset-4 hover:text-primary-hover">
        Go to dashboard
      </Link>
    </div>
  )
}
